/* eslint-disable import/no-default-export */
import { EducationStatus } from '../../firebase/firestore/documents/seeker';

export default {
  send: 'Send',
  email: 'Email',
  language: 'Language',
  search: {
    label: 'Search',
    candidateSearchLabel: 'Search By Candidate Name',
    locationSearchLabel: 'Search By Location Name',
    businessSearchLabel: 'Search By Location Name',
    candidate: 'Candidate',
    business: 'Location',
  },
  sorting: {
    label: 'Sort by:',
    alphabetical: 'A-Z',
    chronological: 'Date',
  },
  grouping: {
    label: 'Group by:',
    none: 'None',
    position: 'Position',
    businessLocation: 'Location',
  },
  tabs: {
    profile: 'Profile',
    audioRecording: 'Language Evaluation',
    messaging: 'Messaging',
    questions: 'Questions',
    notes: 'Notes',
    history: 'History',
    info: 'Information',
    PASS: 'Passed',
    FAIL: 'Failed',
    NEEDS_REVIEW: 'Needs Interview',
  },
  account: {
    switchLang: 'Français',
    logout: 'Logout',
    switchColorMode: {
      dark: 'Switch to light mode',
      light: 'Switch to dark mode',
    },
    administration: 'Administration',
    recruiter: 'Recruiter',
    myProfile: 'My Profile',
  },
  logoutConfirmation: {
    message: 'Are you sure you want to log out of AppyHere?',
    logout: 'Logout',
    cancel: 'Cancel',
  },
  profile: {
    isAStudent: 'Student',
    isStudentInfo: 'This candidate is a student.',
    adult: 'Adult',
    adultInfo: 'This candidate is more than 18 years of age.',
    joinDate: 'Joined APPYHERE: {{date}}',
    appyPros: {
      title: 'Candidate Insights',
      flexibleTransportation: 'Has access to flexible transportation',
      positivePoint: 'Positive point',
    },
    appyNeg: {
      highSalaryDemand: 'High Salary Expectations',
      negativePoint: 'Negative point',
    },
    matchingRequisition: {
      title: 'Ideal Requisitions',
      availabilityFitBand: 'Availability Fit:',
      goodFit: 'Good',
      mediumFit: 'Medium',
      poorFit: 'Poor',
      badFit: 'Poor',
      noFit: 'No Match Calculated',
      not_fitFit: 'No Match Calculated',
      offerMade: 'Make Offer',
    },
    experience: {
      title: 'Experience',
      current: 'Current',
      none: 'No experience',
      fetching: 'Fetching Experience...',
    },
    resume: 'Resume',
    noResumeFound: 'This candidate has not yet uploaded a resume.',
    lastUpdatedResume: 'Uploaded at:',
    noResumePreviewAvailable: 'No Preview Available',
    education: {
      title: 'Education',
      none: 'No education',
      fetching: 'Fetching Education...',
      [EducationStatus.completed]: 'Completed',
      [EducationStatus.ongoing]: 'Ongoing',
      [EducationStatus.dropout]: 'Not Completed',
    },
    availability: {
      title: 'Availability',
    },
    appliedPositions: 'Positions Candidate Has Applied To',
    openRequisitions: 'Open Requisitions',
    noRequisition: 'No Requisition',
    updatedAt: 'Updated at:',
    days: 'Days',
    weeks: 'Weeks',
    immediately: 'Immediately',
    download: 'Download Virtual Resume',
    errorResumeDownload: 'Error when downloading resume.',
    screened: 'Screened',
    nonScreened: 'Not Screened',
    showMore: 'Show Past Applications',
    showLess: 'Hide Past Applications',
  },
  allQuestions: {
    title: 'All Questions',
  },
  requisitions: 'Requisitions',
  questions: {
    title: 'Specific Questions',
    answerPositive: 'Yes',
    answerNegative: 'No',
    totalQuestionAnswered: '{{count}} out of {{total}} questions answered.',
    totalQuestionAnswered_plural: '{{count}} out of {{total}} questions answered.',
    positiveCount: '{{count}} out of {{total}} question answered correctly.',
    positiveCount_plural: '{{count}} out of {{total}} questions answered correctly.',
    knockoutCount: '{{count}} out of {{total}} must-pass question answered correctly.',
    knockoutCount_plural: '{{count}} out of {{total}} must-pass questions answered correctly.',
    emptyQuestions: 'There is no question for {{positionName}}. You can go to the AppyHere Employer mobile app to add some.',
    noAnswers: 'This position has no questions of this type.',
    noDocumentsSubmitted: 'This position has no Document Upload Questions.',
    unansweredEngaged: 'Answers not available.',
    preferredAnswer: 'Preferred Answer',
    knockout: 'Knockout',
    pass: 'PASS',
    fail: 'FAIL',
  },
  freeFormQuestions: {
    title: 'Free Form Questions',
    positiveCount: '{{count}} out of {{total}} question answered',
    unanswered: 'This question is unanswered.',
  },
  videoResponseQuestions: {
    title: 'Video Response Questions',
    positiveCount: '{{count}} out of {{total}} question answered',
    unanswered: 'This question is unanswered.',
    skipped: 'Candidate chose to not to submit video response !',
    noVideoSubmitted: 'This position has no Video Response Questions',
  },
  documentUploadQuestions: {
    title: 'Document Upload Questions',
    positiveCount: '{{count}} out of {{total}} question answered',
    unanswered: 'This question is unanswered.',
    skipped: 'Candidate chose to not to submit document response!',
    noDocumentSubmitted: 'This position has no Document Upload Questions',
    totalDocuments: 'Total {{count}} document',
    totalDocuments_plural: 'Total {{count}} documents',
    previewFailed: 'Failed to load document preview.',
    previewFailedDesc: 'The document viewer took too long to respond. You can retry the preview or download the file directly.',
  },
  toReviewQuestions: {
    reject: 'Incorrect',
    accept: 'Correct',
    message: {
      selectedCorrectAnswer: 'Candidate selected correct answer',
      selectedIncorrectAnswer: 'This is not the correct answer for this question.',
      correctAnswer: 'Correct Answer',
    },
    mcq: {
      correctAnswerDetermination: {
        isEqual: {
          anyOptions: 'The candidate may select any number of options. Their responses must match the correct answers.',
          exactCount: 'The candidate must select exactly {{count}} option. Their responses must match the correct answer.',
          exactCount_plural:
            'The candidate must select exactly {{count}} options. Their responses must match the correct answers.',
        },
        hasAnswer: {
          anyOptions: 'The candidate may select any number of options.',
          atLeastCount: 'The candidate must select at least {{count}} option.',
          atLeastCount_plural: 'The candidate must select at least {{count}} options.',
        },
        doesNotHaveAnswer: {
          anyOptions: 'The candidate may select any number of options. Their responses must not include an incorrect answer.',
          excludeOptions: 'The candidate must not include the specified answer in their response.',
          excludeOptions_plural: 'The candidate must not include the specified answers in their responses.',
        },
        atLeast: {
          anyOptions: 'The candidate may select any number of options, but must include at least one correct answer.',
          includeCount: 'The candidate must include at least {{count}} correct response.',
          includeCount_plural: 'The candidate must include at least {{count}} correct responses.',
        },
      },
    },
  },
  time: {
    relative: {
      lessThan: 'Less than 6 months',
      multipleMonths: '{{value}} months',
      oneYear: '1 year',
      multipleYears: '{{value}} years',
      moreThan: 'More than 10 years',
    },
  },
  appointmentTypes: {
    inPerson: 'in person',
    phone: 'phone',
    video: 'video',
    inPhone: 'Phone',
  },
  noMessage: 'No message, start the conversation!',
  noMessageUnfollowed: 'This candidate has no message history.',
  months: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  monthsSmall: {
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
  },
  informationTab: {
    toastMessage: 'URL Copied',
    headerText: 'WebApply Job Listing URL',
  },
  tooltip: {
    followedPosition: 'Followed Position',
    watchedPosition: 'Watched Position',
    ghostedCandidatesList: 'Show Other Candidate Lists',
    favoriteCandidates: 'My Favorites',
    archivedCandidates: 'Archived Candidates List',
  },
  candidates: {
    favoriteCandidatesList: 'Favorite Candidates List',
    candidatesList: 'Candidates',
    unresponsiveList: 'Unresponsive List',
    archivedList: 'Archived List',
    ghostingList: 'Unresponsive',
    archiveList: 'Archived',
    dismissedList: `Dismissed`,
    agedList: `Candidates Older Than {{config}} Days`,
    recentList: `Recent List`,
  },
  button: {
    cancel: 'Cancel',
    okay: 'Ok',
    create: 'Create',
    add: 'Add',
    later: 'Later',
    save: 'Save',
    retry: 'Retry Preview',
    downloadFile: 'Download File',
  },
  searchAndSort: {
    advanceSearch: 'Advanced Search',
    candidateEngagement: `Candidate Engagement Stage`,
    backgroundCheck: `Background Check Status`,
    ratings: `Rating`,
    experience: `Minimum Experience`,
    salary: `Salary`,
    expectedQuestions: `Position Questions`,
    availability: 'Availability',
    clearAll: `Clear all filters`,
    clearButton: 'Clear All',
    applyButton: 'Apply',
    saveButton: 'Save',
    filter: 'Filter',
    hireStatus: 'Hire Status',
    i9VerificationStatus: ' I-9 Verification Status',
    modernHireStatus: 'Competency Evaluation',
    requisitionsList: 'Requisitions',
    availabilityFit: 'Schedule Matching',
    priority: 'Referred Candidates',
    kiosk: 'Kiosk Candidates',
    actionRequiredCandidates: 'Needs Recruiter Intervention',
    activeFilters: 'Active Filters',
    resetBtn: 'Reset',
  },
  favoriteCandidate: {
    favoriteCandidate: `Favorite Candidates`,
  },
  cadidateEngagementView: {
    engaged: `Engaged`,
    interviewCompleted: `Interview Completed`,
    hired: `Hired`,
    dismissed: `Dismissed`,
    OfferMade: `Made`,
    offerRejected: 'Rejected',
    offerAccepted: 'Accepted',
    appointmentRequested: `Requested`,
    appoinmentAccepted: 'Accepted',
    appoinmentDeclined: 'Declined',
    appoinmentCancled: 'Canceled',
    noAppointmentRequest: 'Pre-Screened',
    interestRevoked: 'Interest Revoked',
    contactRequestDeclined: 'Contact Request Declined',
    interview: 'Interview',
    onDemandInterview: 'On-Demand Interview',
    offer: 'Offer',
    onDemandInterviewRequested: 'Requested',
    onDemandInterviewAccepted: 'Accepted',
    onDemandInterviewDeclined: 'Declined',
    onDemandInterviewCanceled: 'Canceled',
  },
  backgroundCheck: {
    done: `Completed`,
    partiallyDone: `Partially Completed`,
    notDone: `Not Completed`,
    Sent: `Sent`,
    IN_PROGRESS: `In Progress`,
    DISPUTE: `Dispute`,
  },
  availability: {
    day: 'Day',
    night: 'Night',
    evening: 'Evening',
  },
  salary: {
    hourly: `Hourly`,
    annual: `Annual`,
    weekly: `Weekly`,
    monthly: `Monthly`,
    unit: `Unit`,
    min: `Min`,
    max: `Max`,
  },
  experience: {
    yr: `year`,
    yrs: `years`,
  },
  expectedQuestions: {
    typeYourQuestion: `Select your question`,
    expectedQuestion: `Questions`,
    expectedAnswer: `Expected answer`,
    yes: `Yes`,
    no: `No`,
  },
  unresponsivePeriod: {
    day: `day`,
    days: `days`,
    agedPeriod: `Delay before a candidate is considered unresponsive`,
    agedPeriodInfo: `A candidate is considered unresponsive if they haven’t responded to an outstanding request in the number of days set with this parameter. Once this delay is passed, the candidate will be moved to the Unresponsive List.`,
    agedToDismissedPeriod: `Delay before an unresponsive candidate is dismissed`,
    agedToDismissedPeriodInfo: `This slider sets the delay before an unresponsive candidate is dismissed by the system.`,
    configUpdateFailed: `Failed to update configuration.`,
    configUpdateScuccess: `Configuration updated successfully.`,
  },
  interviewFeedBack: ' Candidate Assessment',
  earliestAvailabilityDate: 'Earliest Available Date',
  noticePeriod: 'Notice Period',
  expectedWork: 'Available Work Hours',
  immediately: 'Immediately',
  videoInterviewReminder: {
    candidateInfo: 'Interview Information',
    name: 'Candidate Name',
    position: 'Position',
    location: 'Location',
    email: 'Email',
    close: 'Close',
    joinInterview: 'Join Interview',
  },
  candidateDetailsDrawer: {
    details: 'Details',
    positionDetails: 'Position Information',
    candidateDetail: 'Candidate Information',
    candidateName: 'Candidate Name',
    email: 'Email',
    phone: 'Phone',
  },
  hrsWeek: 'hrs/Week',
  days: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  candidatesHours: 'Candidate Hours',
  analytics: {
    notAllowed: 'This account does not have any analytics reports configured.',
    listOfAccessiblePages: 'Page List',
  },
  pagination: {
    showingResult: 'Showing {{currentItemsLength}} of {{totalItemsLength}} results',
    itemsPerPage: 'Tasks per page:',
  },
  expand: 'Expand',
  remove: 'Remove',
  keepRegardlessLabel: 'Did not provide expected answer to all questions.',
  keepRegardlessBtn: 'Keep Regardless',
  onKeepRegardlessSuccesLabel: 'Successfully saved candidate from dismissal',
  hoursToDismissal: {
    zero: 'Will disappear from this list in a few minutes',
    one: 'Will disappear from this list in one hour',
    other: 'Will disappear from this list in {{count}} hours',
  },
  interviewCandidate: {
    addNote: 'Add Note',
    notes: 'Notes',
    saveNote: 'Save Note',
  },
  noPermission: 'You do not have permission for this action',
  somethingWentWrong: 'Something went wrong.',
  noDataAvailable: 'No Data Available',
  stringArrayInput: {
    placeholder: 'Add new ID',
    add: 'Add',
  },
  confirmPopover: {
    confirm: 'Yes',
    cancel: 'No',
  },
};
